module.exports = __webpack_public_path__ + "static/media/company8Text.6e82e56c.png";